import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import useAppState from "context/useAppState";

interface Iprops {
  showLegends: boolean;
  colors: string[];
  series: number[];
  height?: string;
  width?: string;
  labels?: string[]
}

const DonutChart = ({ showLegends, colors, series, height, width, labels }: Iprops) => {
  const {
    setState,
    downloadChart,
    downloadChartName,
    chartName
  } = useAppState("eventData");

  const chartRef = React.useRef<any>(null);

  useEffect(() => {
    if (downloadChart) {
      downloadAsSVG()
      setState({ downloadChart: false })
    }
  }, [downloadChart])

  const downloadAsSVG = async () => {
    if (chartRef.current && chartName == 'donut_chart') {
      try {
        await chartRef.current.chart.exports.exportToSVG(); // Use getSVGString for SVG data
      } catch (error) {
        console.error("Error downloading chart:", error);
      }
    }
  };

  const chartOptions: ApexOptions = {
    chart: {
      type: "donut",
      width: 20,
      toolbar: {
        show: false,
        export: {
          svg: {
            filename: downloadChartName
          }
        }
      },
    },
    stroke: {
      width: 0,
    },
    // labels: ["Maybe", "Yes", "No", "No response"],
    labels: labels,
    series: series,
    colors: colors,
    dataLabels: {
      enabled: false, // Disable data labels
    },
    tooltip: {
      enabled: true, // Enable tooltips on hover (optional)
    },
    legend: {
      show: showLegends, // Show legend for color indications (optional)
      position: "bottom",
      labels: {
        colors: "#333", // Legend text color
        useSeriesColors: true, // Use custom colors instead of series colors
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "74%"
          //  size: "78%"
        }
      }
    }
  };

  return (
    <div>
      <ReactApexChart
        ref={chartRef}
        options={chartOptions}
        series={chartOptions.series}
        type='donut'
        height={height || 190}
        width={width || 220}
      />
    </div>
  );
};

export default DonutChart;
